import field from "../mixins/field";
import translate from "./i18n";

export default {
    name: 'FormDoubleInput',
    mixins: [field],
    methods: {
        getComparedValues(values) {
            const { gte, lte } = values;
            if (gte == null || gte === '' || lte == null || lte === '') return values;
            if (Number(gte) > Number(lte)) {
                return {
                    gte: lte,
                    lte: gte,
                };
            }
            return values;
        },
        parseNumericValue(value) {
            if (value === '' || value == null) return null;
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : null;
        },
        handleChange(event) {
            const { name, value } = event.target;
            const combinedValues = Object.assign({}, this.fieldData.value, {
                [name]: this.parseNumericValue(value),
            });
            const comparedValues = this.getComparedValues(combinedValues);
            this.fieldChange({
                name: this.fieldData.fieldName,
                value: comparedValues,
            });
        },
    },
    i18n: {
        ...translate
    },
}
